<div class="content" [ngClass]="{ 'no-padding': noPadding }">
  <ng-content></ng-content>
</div>
